// extracted by mini-css-extract-plugin
module.exports = {"fullPage":"removeGroup_fullPage__3DMEr","buttons":"removeGroup_buttons__3AsaH","removeGroupTable":"removeGroup_removeGroupTable__2AUdv"};